import {
  cta_buttonPrimaryBackground,
  text_colorTextPrimary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { fontH3, fontRegular } from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  &.UpdateVirtualCardPickContent {
    .declining-balance-box {
      display: flex;
      align-items: center;
      cursor: pointer;
      transition: box-shadow 50ms ease-out;
      margin-top: ${spacing(5)};

      &:hover {
        box-shadow:
          0 1px 5px 0 rgba(0, 0, 0, 0.15),
          inset 0px 0px 0px 1px var(--color-cta);
      }

      &.disabled {
        opacity: 50%;
        cursor: default;

        &:hover {
          box-shadow: none;
        }
      }
    }

    .declining-balance-image {
      flex-shrink: 0;
    }

    .declining-balance-text {
      display: flex;
      flex-direction: column;
      margin-left: ${spacing(8)};
    }

    .declining-balance-title {
      ${fontH3};
      color: ${cta_buttonPrimaryBackground};
      display: flex;
      align-items: center;
      margin-bottom: ${spacing(2)};
    }

    .declining-balance-subtitle {
      ${fontRegular};
      color: ${text_colorTextPrimary};
    }
  }
`
